var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M47.141 6.039A22 22 0 0010 21.732a21.862 21.862 0 008.436 17.591A6.89 6.89 0 0121 44.732v1.452a2.982 2.982 0 000 5.632V55a9.011 9.011 0 009 9h4a9.011 9.011 0 009-9v-3.184a2.982 2.982 0 000-5.632v-1.453a6.914 6.914 0 012.576-5.419 22 22 0 001.565-33.273zM41 55a7.008 7.008 0 01-7 7h-4a7.008 7.008 0 01-7-7v-3h18zm1-5H22a1 1 0 010-2h20a1 1 0 010 2zM32 14a2 2 0 112-2 2 2 0 01-2 2zm12.34 23.739A8.93 8.93 0 0041 44.731V46h-3V31.414l3.981-3.981A3.947 3.947 0 0044 28a4 4 0 10-4-4 3.947 3.947 0 00.567 2.019l-4.274 4.274A1 1 0 0036 31v15h-3V15.858a4 4 0 10-2 0V46h-3V35a1 1 0 00-.293-.707l-4.274-4.274A3.947 3.947 0 0024 28a4 4 0 10-4 4 3.947 3.947 0 002.019-.567L26 35.414V46h-3v-1.268a8.907 8.907 0 00-3.329-6.983A19.876 19.876 0 0112 21.756 20.274 20.274 0 0130.921 2.028 20 20 0 0144.34 37.739zM42 24a2 2 0 112 2 2 2 0 01-2-2zm-22 6a2 2 0 112-2 2 2 0 01-2 2z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M42 12a3 3 0 00-3 3 2.951 2.951 0 00.3 1.285l-3.008 3.008A1 1 0 0036 20v5a1 1 0 002 0v-4.586l2.715-2.714A2.951 2.951 0 0042 18a3 3 0 000-6zm0 4a1 1 0 111-1 1 1 0 01-1 1zm-15.3 5.285A2.951 2.951 0 0027 20a3 3 0 10-3 3 2.951 2.951 0 001.285-.3l.715.715V28a1 1 0 002 0v-5a1 1 0 00-.293-.707zM23 20a1 1 0 111 1 1 1 0 01-1-1zm20.293 9.293l-3 3A1 1 0 0040 33v3a1 1 0 002 0v-2.586l2.707-2.707a1 1 0 00-1.414-1.414zM23 39a1 1 0 001-1v-2a1 1 0 00-2 0v2a1 1 0 001 1zm40-19h-4a1 1 0 000 2h4a1 1 0 000-2zM55.384 8.5a1 1 0 00.5-.134l3.464-2a1 1 0 00-1-1.732l-3.464 2a1 1 0 00.5 1.866zm3.963 25.134l-3.464-2a1 1 0 10-1 1.732l3.464 2a1 1 0 001-1.732zM6 21a1 1 0 00-1-1H1a1 1 0 000 2h4a1 1 0 001-1zM9.117 6.634l-3.464-2a1 1 0 10-1 1.732l3.464 2a1 1 0 101-1.732zm-1 25l-3.464 2a1 1 0 101 1.732l3.464-2a1 1 0 10-1-1.732z",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 10,
    fill: "#fff",
    "data-original": "#ffffff",
    rx: 1,
    ry: 2,
    transform: "rotate(-45 45.002 10.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 13,
    r: 1,
    fill: "#fff",
    "data-original": "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovationIcon);
export default __webpack_public_path__ + "static/media/InnovationIcon.f598d717554bc81ed33d5035805b9e25.svg";
export { ForwardRef as ReactComponent };